<template>
</template>

<script>
import errorHandling from "../../helper/errorHandling";
import axios from 'axios';
import authenticate from "../../helper/authenticate";

export default {
  components: {
  },
  data() {
    return {
    }
  },
  mounted(){
  },
  watch: {
  },
  methods:{
  },
}
</script>

<style lang="scss" scoped>

</style>